// Utilitaires YouTube : extraction d'ID, miniature, URL embed.

/** Extraction défensive d'un ID YouTube depuis les formats courants (ou un ID brut). */
export function normalizeYouTubeId(input?: string | null): string | null {
  if (!input) return null;
  const s = input.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  const patterns = [
    /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/live\/)([a-zA-Z0-9_-]{11})/,
    /[?&]v=([a-zA-Z0-9_-]{11})/,
  ];
  for (const p of patterns) { const m = s.match(p); if (m) return m[1]; }
  return null;
}

export function isYouTubeUrl(url?: string | null): boolean {
  return !!url && (url.includes('youtube.com') || url.includes('youtu.be'));
}

/** Alias de compatibilité (utilisé par l'admin). */
export const extractYouTubeId = normalizeYouTubeId;

export function youtubeThumbnail(videoId: string, quality: 'maxres' | 'hq' | 'mq' = 'hq'): string {
  const id = normalizeYouTubeId(videoId);
  if (!id) return '';
  const map = { maxres: 'maxresdefault', hq: 'hqdefault', mq: 'mqdefault' };
  return `https://i.ytimg.com/vi/${id}/${map[quality]}.jpg`;
}

/**
 * URL embed YouTube (domaine standard pour compat maximale d'embed).
 * autoplay activé car appelée seulement après le clic utilisateur → conforme navigateurs.
 */
export function youtubeEmbedUrl(videoId: string): string {
  const id = normalizeYouTubeId(videoId) || videoId;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://proxyemobility.com';
  const params = new URLSearchParams({
    autoplay: '1', rel: '0', modestbranding: '1', playsinline: '1', origin,
  });
  return `https://www.youtube.com/embed/${id}?${params.toString()}`;
}
